module.exports = __webpack_public_path__ + "img/mainPicture.7ff2faa9.png";